var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1176.463",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.156 90.017h104.608V307.21H379.196zm0 446.15h104.608v217.234H379.196zm0-165.546h104.608v102.496H379.196zm-168.02-102.055h104.57v722.01h-104.61zm332.608 446.827h104.608v217.193H543.744zm0-446.55h104.608v217.195H543.744zm0 280.644h104.608V651.98H543.744zm164.55-516.06h104.61v722.01h-104.61z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.03d98372ca734332d635b5ba2cb11072.svg";
export { ForwardRef as ReactComponent };